export default __webpack_public_path__ + "static/mian-arif-338cfcac5cc27bebc9d8da34958dd084.jpg";